const ROTATE_DEFAULT = 0;
const ROTATE_90 = 90;
const ROTATE_180 = 180;
const ROTATE_270 = 270;

export default {
    ROTATE_DEFAULT,
    ROTATE_90,
    ROTATE_180,
    ROTATE_270
}